<template>
  <div class="content" @touchmove.prevent>
    <Header :title="title" @toBack="toBack"></Header>
    <div
      :class="{
        box: true,
        box2: isStep == 2,
      }"
    >
      <!-- 短信找回 -->
      <div class="step1" v-if="isStep == 1">
        <div class="font1">校验手机号找回密码</div>
        <div class="codeInputBox">
          <div
            class="pcodeBox"
            v-if="codeList.length > 0"
            @click="showCode = true"
          >
            <span class="font2">{{ pcode }}</span>
            <svg-btn class="icon" icon-class="icon-short-hcode"></svg-btn>
          </div>
          <FmInput
            v-model="phone"
            :class="inputClass"
            placeholder="请输入手机号"
            clearable
          ></FmInput>
        </div>
        <fm-button
          class="loginBt"
          type="primary"
          :disabled="btnOne"
          round
          size="medium"
          @click="stepOne"
          >下一步</fm-button
        >
      </div>
      <!-- 验证手机号 -->
      <div class="step2" v-if="isStep == 2">
        <div class="topInfo">
          请输入发送至
          <span>{{
            pcode + phone.slice(0, 3) + '******' + phone.slice(9, 11)
          }}</span>
          的 6 位验证码，有效期 3 分钟
        </div>
        <VerificationCode
          ref="ver"
          :isError="isError"
          :codeValue="ucode"
          @updateValue="getValue"
        >
        </VerificationCode>
        <div class="timeBox">
          <div>
            <span v-if="time === 60" @click="againGetCode(0)"
              >重新获取验证码</span
            >
            <span v-if="time < 60">{{ time }}s后重新获取</span>
          </div>
          <span v-if="time === 60 && updateGet" @click="againGetCode(2)"
            >未收到验证码？</span
          >
        </div>
        <div class="btBox">
          <fm-button
            class="loginBt"
            type="primary"
            :disabled="btnTwo"
            round
            size="medium"
            @click="stepTwo"
            >确定</fm-button
          >
        </div>
      </div>
      <!-- 重设密码 -->
      <div class="step3" v-if="isStep == 3">
        <div class="font1">请设置新密码，最少设置6位数字或字母</div>
        <FmInput
          style="margin-bottom: 12px"
          v-model="password"
          class="loginInput"
          placeholder="新密码"
          type="password"
          clearable
        ></FmInput>
        <FmInput
          v-model="cpassword"
          class="loginInput"
          placeholder="再次输入新密码"
          type="password"
          clearable
        ></FmInput>
        <fm-button
          class="loginBt"
          type="primary"
          :disabled="btnThree"
          :loading="loading"
          round
          size="medium"
          @click="stepThree"
          >确定</fm-button
        >
      </div>
    </div>
    <pcodeCheck
      @touchmove.stop
      :codeList="codeList"
      :show="showCode"
      :code="pcode"
      @close="showCode = false"
      @toCheck="toCheck"
    />
    <wxLink
      :isShow="wxLinkShow"
      :isCancel="false"
      :forgetText="forget.forget_time"
      title="暂时无法修改密码"
      submitText="我知道了"
      :content="forget.forget_text"
      @submit="submitLink"
    />
  </div>
</template>

<script>
import Header from '@/components/NavTopLogin/index.vue'
import pcodeCheck from '@/components/pcodeCheck/index.vue'
import VerificationCode from '@/components/VerificationCode/index.vue'
import wxLink from '@/components/Dialog/wxLink.vue'
import {
  getPhonePcodeAPI,
  forgetPasswordAPI,
  resetPasswordAPI,
  phoneLoginCodeAPI,
} from '@/axios/login'
export default {
  name: 'forget',
  components: {
    Header,
    pcodeCheck,
    VerificationCode,
    wxLink,
  },
  data() {
    return {
      phone: '',
      pcode: '+86',
      isStep: 1,
      title: '短信找回',
      showCode: false,
      ucode: '', //验证码字段
      time: 60,
      timerA: '',
      updateGet: false,
      password: '',
      cpassword: '',
      sms_type: 0,
      wxLinkShow: false,
      codeList: [],
      msgid: '',
      forget: {},
      validate: {},
      isError: false,
      loading: false,
    }
  },
  watch: {
    deviceClass() {
      if (this.deviceClass == 'pc') {
        window.location.replace(`${this.$glb.feemooUrl}/login?path=drive`)
      }
    },
    ucode() {
      if (this.ucode.length < 6) {
        this.isError = false
      }
    },
  },
  mounted() {
    if (this.deviceClass == 'pc') {
      window.location.replace(`${this.$glb.feemooUrl}/login?path=drive`)
    }
    this.getPhonePcode()
  },
  computed: {
    deviceClass() {
      return this.$store.getters['device/deviceClass']
    },
    inputClass() {
      if (this.codeList.length > 0) {
        return `codeInput${this.pcode.length - 1}`
      } else {
        return 'loginInput'
      }
    },
    btnOne() {
      if (this.pcode == '+86' && this.phone.length == 11) {
        return false
      } else if (this.pcode != '+86' && this.phone) {
        return false
      }
      return true
    },
    btnTwo() {
      if (this.ucode.length == 6) {
        return false
      }
      return true
    },
    btnThree() {
      if (
        this.password.trim().length >= 6 &&
        this.cpassword.trim().length >= 6
      ) {
        return false
      }
      return true
    },
  },
  methods: {
    //获取区号
    getPhonePcode() {
      // type: 1是注册的区号 2是登录 3是忘记密码的区号 4是绑定手机号
      getPhonePcodeAPI({ type: 3 }).then(res => {
        if (res.status == 1) {
          this.codeList = res.data.list
        }
      })
    },
    //清除输入验证码数据
    clearOp() {
      this.time = 60
      this.timerA && clearInterval(this.timerA)
    },
    //发送验证码
    stepOne: _.debounce(
      function (captcha_verify, validate = {}) {
        if (validate == 'close') {
          return
        }
        if (this.btnOne) {
          return
        }
        this.clearOp()
        return new Promise(resolve => {
          let data = {
            lot_number: validate?.lot_number || '',
            captcha_output: validate?.captcha_output || '',
            pass_token: validate?.pass_token || '',
            gen_time: validate?.gen_time || '',
            captcha_verify: captcha_verify || '',
            phone: this.phone,
            pcode: this.pcode,
            code_type: 1, //验证码类型：0-短信登录注册 1-短信找回密码 2-修改手机号
            sms_type: this.sms_type,
          }
          this.validate = validate
          phoneLoginCodeAPI(data)
            .then(res => {
              if (res.status == 1) {
                this.isStep = 2
                this.title = '验证手机号'
                this.ucode = ''
                this.$nextTick(() =>{
                  this.$refs.ver?.reset()
                })
                this.msgid = res.data.msgid
                this.$htoast(res.msg)
                this.timerA = setInterval(() => {
                  this.minute()
                }, 1000)
                resolve({
                  result: true,
                  validate: true,
                })
              } else if (res.status == 4000) {
                resolve({
                  result: true,
                  validate: true,
                })
                this.$htoast(res.msg)
              } else if (res.status == 9000) {
                resolve({
                  result: false,
                  validate: false,
                })
                this.$htoast(res.msg)
                this.$AliCode.handleOpen(this.stepOne)
              } else if (res.status == 90002) {
                this.$utils.initgt4(
                  '5b0562a75492b420626b745b229e83a4',
                  this.stepOne
                )
              } else if (res.status == '90300') {
                this.forget = {
                  forget_time: res.data.update_time || '',
                  forget_text: res.msg || '',
                }
                this.wxLinkShow = true
              } else {
                this.$htoast(res.msg)
                resolve({
                  result: true,
                  validate: false,
                })
              }
            })
            .catch(err => {})
        })
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //验证验证码
    stepTwo: _.debounce(
      function () {
        if (this.btnTwo) {
          return
        }
        let data = {
          lot_number: this.validate?.lot_number,
          captcha_output: this.validate?.captcha_output,
          pass_token: this.validate?.pass_token,
          gen_time: this.validate?.gen_time,
          phone: this.phone,
          pcode: this.pcode,
          ucode: this.ucode,
          msgid: this.msgid,
        }
        forgetPasswordAPI(data)
          .then(res => {
            if (res.status == 1) {
              this.$htoast(res.msg)
              //重设密码
              this.password = ''
              this.cpassword = ''
              this.isStep = 3
              this.title = '重设密码'
            } else {
              this.isError = true
              this.$htoast(res.msg)
            }
          })
          .catch(err => {})
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //修改密码完成
    stepThree: _.debounce(
      function () {
        if (this.btnThree || this.loading) {
          return
        }
        let str = this.password || ''
        if (!/^[a-zA-Z0-9]{6,}$/.test(str)) {
          this.$htoast('请使用数字或字母设置密码')
          return false
        } else if (this.password !== this.cpassword) {
          this.$htoast('密码不一致，请重试')
          return
        }
        this.loading = true
        let data = {
          type: 'phone',
          phone: this.phone,
          pcode: this.pcode,
          ucode: this.ucode,
          msgid: this.msgid,
          password: this.password,
        }
        resetPasswordAPI(data)
          .then(res => {
            if (res.status == 1) {
              this.$htoast(res.msg)
              this.loading = false
              this.$router.replace({ path: '/login' })
              this.password = ''
              this.cpassword = ''
            } else {
              this.loading = false
              this.$htoast(res.msg)
            }
          })
          .catch(err => {
            this.loading = false
          })
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    submitLink() {
      this.wxLinkShow = false
    },
    minute: function () {
      this.time = this.time - 1
      if (this.time == 0) {
        this.time = 60
        this.updateGet = true
        clearInterval(this.timerA)
      }
    },
    //验证码输入回调
    getValue(newValue) {
      this.ucode = newValue
      if (this.ucode.length == 6) {
        //发送手机验证码
        this.stepTwo()
      }
    },
    againGetCode(row) {
      this.sms_type = row
      //发送手机验证码
      this.stepOne()
    },
    toCheck(num) {
      this.pcode = num
      this.showCode = false
    },
    toBack() {
      if (this.isStep == 1) {
        this.$router.replace({ path: '/login' })
      } else if (this.isStep == 2) {
        this.title = '短信找回'
        this.isStep = 1
      } else if (this.isStep == 3) {
        this.title = '验证手机号'
        this.isStep = 2
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-direction: column;
  background: #ffffff;
  overflow: auto;
  height: 100%;
  overflow-x: hidden;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  &::-webkit-scrollbar-thumb {
    display: none;
  }
  &::-webkit-scrollbar-track {
    display: none;
  }
  .box {
    height: 100%;
    padding: 40px 34px 0 34px;
    .step1 {
      display: flex;
      flex-direction: column;
      .font1 {
        font-weight: 400;
        font-size: 14px;
        color: #2c2c2c;
        line-height: 20px;
        margin-bottom: 36px;
      }
      .loginBt {
        width: 100%;
        height: 48px;
        border-radius: 48px;
        margin-top: 24px;
        span {
          font-weight: 500;
          font-size: 14px;
          color: #ffffff;
          line-height: 20px;
        }
      }
    }
    .step2 {
      .topInfo {
        font-weight: 400;
        font-size: 14px;
        color: #8a8b92;
        line-height: 20px;
        text-align: left;
        margin-bottom: 32px;
        width: 100%;
        span {
          color: #2c2c2c !important;
        }
      }
      .timeBox {
        margin-top: 24px;
        font-weight: 400;
        font-size: 14px;
        color: #f67942;
        line-height: 20px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .btBox {
        margin-top: 32px;
        padding: 0 18px;
        .loginBt {
          width: 100%;
          height: 48px;
          border-radius: 48px;
          span {
            font-weight: 500;
            font-size: 14px;
            color: #ffffff;
            line-height: 20px;
          }
        }
      }
    }
    .step3 {
      display: flex;
      flex-direction: column;
      .font1 {
        font-weight: 400;
        font-size: 14px;
        color: #2c2c2c;
        line-height: 20px;
        margin-bottom: 36px;
      }
      .loginBt {
        width: 100%;
        height: 48px;
        border-radius: 48px;
        margin-top: 24px;
        span {
          font-weight: 500;
          font-size: 14px;
          color: #ffffff;
          line-height: 20px;
        }
      }
    }
  }
  .box2 {
    padding-right: 16px;
    padding-left: 16px;
  }
}
</style>
